import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const applyCoupons = createAsyncThunk('coupons/apply', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/coupon/apply-coupon`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  couponsInfo: {},
  error: null
}

const couponsSlice = createSlice({
  name: 'coupons',
  initialState,
  reducers: {
    resetCouponsState: (state) => {
      state.couponsInfo = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(applyCoupons.pending, (state) => {
        state.isLoading = true
      })
      .addCase(applyCoupons.fulfilled, (state, action) => {
        state.isLoading = false
        state.couponsInfo = action.payload?.data?.data
      })
      .addCase(applyCoupons.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})
export const { resetCouponsState } = couponsSlice.actions
export default couponsSlice.reducer
